import React from 'react';
import { useTranslation } from 'react-i18next';

interface SudanesePoundProps {
  amount?: number | string;
  className?: string;
  variant?: 'regular' | 'bold' | 'new' | 'bold_new';
  showAmount?: boolean;
}

export const SudanesePound: React.FC<SudanesePoundProps> = ({ 
  amount, 
  className = '', 
  variant = 'new',
  showAmount = true 
}) => {
  const { i18n } = useTranslation();

  const formatAmount = (value: number | string) => {
    if (typeof value === 'number') {
      return value.toLocaleString(i18n.language === 'ar' ? 'ar-SD' : 'en-SD');
    }
    return value;
  };

  const getCurrencySymbol = () => {
    return i18n.language === 'ar' ? 'جنيه سوداني' : 'SDG';
  };

  return (
    <span className={`inline-flex items-center gap-1 ${className}`} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
      {showAmount && amount && (
        <span>{formatAmount(amount)}</span>
      )}
      <span className="text-sm font-medium text-muted-foreground">
        {getCurrencySymbol()}
      </span>
    </span>
  );
};

export default SudanesePound;
